/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_Image_AltInputs */

const en_gc_resources_features_image_alt = /** @type {(inputs: Gc_Resources_Features_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft spreadsheet showing formatting and a chart`)
};

const zh_gc_resources_features_image_alt = /** @type {(inputs: Gc_Resources_Features_Image_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 中的表格格式设置与图表`)
};

/**
* | output |
* | --- |
* | "GridCraft spreadsheet showing formatting and a chart" |
*
* @param {Gc_Resources_Features_Image_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_image_alt = /** @type {((inputs?: Gc_Resources_Features_Image_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_Image_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_image_alt(inputs)
	return zh_gc_resources_features_image_alt(inputs)
});
export { gc_resources_features_image_alt as "gc.resources.features.image_alt" }